import { Modal } from "antd";
import { useEffect, useState } from "react";
import dayjsTZ from "../../../utils/dayjs";
import { Eagle, Snowflake } from "../icons";
import HappyThanksGiving from "../pictures/FlexThanksGiving.png";
import HappyAutumn from "../pictures/HappyAutumn.jpg";
import HappyHolidays from "../pictures/HappyHolidays.png";
import "./HappyHolidays.scss";

const STORAGE_KEY = "flexhrSeasonalModal";

const MODAL_ASSETS = {
  halloween: {
    type: "image",
    src: HappyAutumn,
    alt: "Happy Halloween",
  },
  autumn: {
    type: "image",
    src: HappyAutumn,
    alt: "Happy Autumn",
  },
  thanksgiving: {
    type: "image",
    src: HappyThanksGiving,
    alt: "Happy Thanksgiving",
  },
  winter: {
    type: "image",
    src: HappyHolidays,
    alt: "Happy Holidays",
  },
  summer: {
    type: "card",
    title: "Mirësevini në Verë!",
    subtitle: "Det · Diell · Pushime",
    className: "seasonal-card--summer",
  },
  albaniaFlag: {
    type: "card",
    title: "Gëzuar Ditën e Flamurit!",
    subtitle: "28 Nëntor — Dita e Pavarësisë",
    className: "seasonal-card--albania",
    showEagle: true,
  },
};

/**
 * Shows once per theme window (cooldown 8h), keyed by themeId.
 */
function HappyHolidaysModal({ themeId, enabled = true }) {
  const [visible, setVisible] = useState(false);
  const asset = MODAL_ASSETS[themeId];

  useEffect(() => {
    if (!enabled || !themeId || !asset) {
      setVisible(false);
      return;
    }

    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const map = raw ? JSON.parse(raw) : {};
      const last = map[themeId];
      const now = dayjsTZ().valueOf();
      if (last && dayjsTZ().diff(dayjsTZ(last), "hours", true) <= 8) {
        setVisible(false);
        return;
      }
      map[themeId] = now;
      localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
      setVisible(true);
    } catch {
      setVisible(true);
    }
  }, [themeId, enabled, asset]);

  if (!asset) return null;

  return (
    <Modal
      wrapClassName={`happy-holidays-modal happy-holidays-modal--${themeId}`}
      centered
      open={visible}
      width={asset.type === "card" ? 560 : 900}
      title={null}
      footer={null}
      closeIcon={<Snowflake />}
      onCancel={() => setVisible(false)}
      destroyOnHidden
    >
      {asset.type === "image" ? (
        <img
          className="image-happy-holidays"
          src={asset.src}
          alt={asset.alt}
        />
      ) : (
        <div className={`seasonal-card ${asset.className || ""}`}>
          {asset.showEagle ? (
            <Eagle className="seasonal-card__eagle" />
          ) : (
            <div className="seasonal-card__icon" aria-hidden="true" />
          )}
          <h2 className="seasonal-card__title">{asset.title}</h2>
          <p className="seasonal-card__subtitle">{asset.subtitle}</p>
        </div>
      )}
    </Modal>
  );
}

export default HappyHolidaysModal;
